// @flow
import React, { Component } from 'react';

import './PinItButton.css';


export default class PinItButton extends Component {


    BASE_URL = 'https://www.pinterest.com/pin/create/button/';


    componentWillMount() {
        setTimeout(() => {
            window.parsePins(this.el);
        }, 100);
    }


    preventClose (event) {
        event.stopPropagation();
    }


    getPinUrl() {
        let url = this.BASE_URL + '?';
        url += `media=${encodeURIComponent(this.props.imgUrl)}`;
        url += `&url=${encodeURIComponent(window.document.URL)}`;
        url += `&description=${encodeURIComponent(this.props.description)}`;

        return url;
    }


    componentWillUpdate(nextProps, nextState) {
        if (this.el) {
            let el = this.el.querySelector('[data-pin-href]');

            el.dataset.pinHref = this.getPinUrl();

        }

    }


    render () {
        let w = this.props.width,
            h = this.props.height,
            style = {};

        if (w && h) {
            style.transform = (
                `translate(${ -0.5 * w + 10 }px, ${ -0.5 * h + 10 }px)`);
            style.display = 'block';

        }

        return (
            <div
                style={ style }
                onClick={ this.preventClose }
                ref={(el) => { this.el = el; }}
                className="ln-pin-btn">
                <a
                    data-pin-do="buttonPin"
                    data-pin-tall="true"
                    data-pin-lang="pl"
                    data-pin-save="true"
                    href={ this.getPinUrl() }>
                </a>
            </div>);
    }

}



// WEBPACK FOOTER //
// ./src/components/PinItButton/PinItButton.js